import axios from 'axios'
import http from '@/http'
import { create } from '../action-helpers'
import * as mutations from '../mutation-types'

export default {

    create: create('product-templates'),

    async loadAll({ commit }) {
        const response = await http({ method: 'GET', url: 'product-templates' })
        commit(mutations.SET_MANY, { content: response.data })
    },

    async remove({ commit }, { id }) {
        await axios.delete(`/api/v1/product-templates/${id}`)
        commit('REMOVE', { content: { id } })
    },

}
